import React from 'react';
import type { Asset } from '../../../api/models/asset.model.ts';
import ModifyUserDefinedFieldsModal from './ModifyUserDefinedFieldsModal.tsx';
import { useUpdateNonLeasedUdfValuesMutation } from '../../../api/asset.api.ts';
import { showAlert } from '../../../redux/slices/alertSlice.ts';
import { useDispatch } from 'react-redux';

interface ModifyNonLeasedUserDefinedFieldsModalProps {
	open: boolean;
	onClose: () => void;
	selectedRows: Asset[];
}


function ModifyNonLeasedUserDefinedFieldsModal({ open, onClose, selectedRows }: ModifyNonLeasedUserDefinedFieldsModalProps) {

	const dispatch = useDispatch();
	const [ updateNonLeasedUdfAssets ] = useUpdateNonLeasedUdfValuesMutation();
	const [ isSubmitting, setIsSubmitting ] = React.useState(false);

	const callUpdateUdfValues = async (udfValues: Record<string, string>) => {
		try {
			setIsSubmitting(true);
			await updateNonLeasedUdfAssets({
				assetIds: selectedRows,
				udfValues
			}).unwrap();

			dispatch(showAlert({
				message: 'Updated successfully',
				type: 'success',
			}));
			onClose();
		} catch (error) {
			dispatch(showAlert({
				message: 'Update failed. Please try again.',
				type: 'error',
			}));
		} finally {
			setIsSubmitting(false);
		}
	}
	
	return (<ModifyUserDefinedFieldsModal
		open={open}
		onClose={onClose}
		selectedRows={selectedRows}
		callUpdateUdfValues={callUpdateUdfValues}
		downstreamCallInProgress={isSubmitting}
	/>)
}

export default ModifyNonLeasedUserDefinedFieldsModal;